module.exports = __webpack_public_path__ + "img/3.7257bc98.jpg";